export default __webpack_public_path__ + "static/entertainment-a44251a98d131ad116d9c3bd84b66464.png";